import { Button, IconEdit16, IconTrash16, UIText1 } from '@cian/ui-kit';
import React from 'react';

import * as styles from './Note.css';

type TProps = {
  note: string;
  onEdit: () => void;
  onDelete: () => void;
};

export const Note: React.FC<TProps> = ({ note, onEdit, onDelete }) => {
  return (
    <div className={styles['container']}>
      <UIText1>{note}</UIText1>
      <div className={styles['buttons']}>
        <Button theme="fill_secondary" onClick={onEdit} size="XS" beforeIcon={<IconEdit16 color="primary_100" />} />
        <Button theme="fill_secondary" onClick={onDelete} size="XS" beforeIcon={<IconTrash16 color="primary_100" />} />
      </div>
    </div>
  );
};
